tinymce.addI18n("es_MX", {
    "#": "#",
    "Accessibility": "Accesibilidad",
    "Accordion": "Acorde\xf3n",
    "Accordion body...": "Cuerpo de acorde\xf3n...",
    "Accordion summary...": "Resumen en estilo acorde\xf3n...",
    "Action": "Acci\xf3n",
    "Activity": "Actividad",
    "Address": "Direcci\xf3n",
    "Advanced": "Avanzado",
    "Align": "Alinear",
    "Align center": "Alinear al centro",
    "Align left": "Alinear a la izquierda",
    "Align right": "Alinear a la derecha",
    "Alignment": "Alineaci\xf3n",
    "Alignment {0}": "Alineamiento {0}",
    "All": "Todo",
    "Alternative description": "Descripci\xf3n alternativa",
    "Alternative source": "Origen alternativo",
    "Alternative source URL": "URL de origen alternativo",
    "Anchor": "Ancla",
    "Anchor...": "Ancla...",
    "Anchors": "Anclajes",
    "Animals and Nature": "Animales y naturaleza",
    "Arrows": "Flechas",
    "B": "A",
    "Background color": "Color de fondo",
    "Background color {0}": "Color de fondo {0}",
    "Black": "Negro",
    "Block": "Bloque",
    "Block {0}": "Bloque {0}",
    "Blockquote": "Cita en bloque",
    "Blocks": "Bloques",
    "Blue": "Azul",
    "Blue component": "Componente azul",
    "Body": "Cuerpo",
    "Bold": "Negrita",
    "Border": "Borde",
    "Border color": "Color del borde",
    "Border style": "Estilo del borde",
    "Border width": "Ancho del borde",
    "Bottom": "Inferior",
    "Browse files": "Explorar archivos",
    "Browse for an image": "Buscar una imagen",
    "Browse links": "Explorar enlaces",
    "Bullet list": "Lista de vi\xf1etas",
    "Cancel": "Cancelar",
    "Caption": "Subt\xedtulo",
    "Cell": "Celda",
    "Cell padding": "Espaciado entre borde y texto",
    "Cell properties": "Propiedades de celda",
    "Cell spacing": "Espaciado entre celdas",
    "Cell styles": "Estilos de celda",
    "Cell type": "Tipo de celda",
    "Center": "Centro",
    "Characters": "Caracteres",
    "Characters (no spaces)": "Caracteres (sin espacios)",
    "Circle": "C\xedrculo",
    "Class": "Clase",
    "Clear formatting": "Borrar formato",
    "Close": "Cerrar",
    "Code": "C\xf3digo",
    "Code sample...": "Ejemplo de c\xf3digo...",
    "Code view": "Vista de c\xf3digo",
    "Color Picker": "Selector de colores",
    "Color swatch": "Muestrario de colores",
    "Cols": "Cols",
    "Column": "Columna",
    "Column clipboard actions": "Acciones de columna del portapapeles",
    "Column group": "Grupo de columnas",
    "Column header": "Encabezado de columna",
    "Constrain proportions": "Restringir proporciones",
    "Copy": "Copiar",
    "Copy column": "Copiar columna",
    "Copy row": "Copiar fila",
    "Could not find the specified string.": "No se ha encontrado la cadena indicada.",
    "Could not load emojis": "No se pudieron cargar los emojis",
    "Count": "Cantidad",
    "Currency": "Divisa",
    "Current window": "Ventana actual",
    "Custom color": "Color personalizado",
    "Custom...": "Personalizado...",
    "Cut": "Cortar",
    "Cut column": "Cortar columna",
    "Cut row": "Cortar fila",
    "Dark Blue": "Azul oscuro",
    "Dark Gray": "Gris oscuro",
    "Dark Green": "Verde oscuro",
    "Dark Orange": "Anaranjado oscuro",
    "Dark Purple": "Morado oscuro",
    "Dark Red": "Rojo oscuro",
    "Dark Turquoise": "Turquesa oscuro",
    "Dark Yellow": "Amarillo oscuro",
    "Dashed": "Discontinuo",
    "Date/time": "Fecha/hora",
    "Decrease indent": "Reducir sangr\xeda",
    "Default": "Predeterminado",
    "Delete accordion": "Borrar acorde\xf3n",
    "Delete column": "Eliminar columna",
    "Delete row": "Eliminar fila",
    "Delete table": "Eliminar tabla",
    "Dimensions": "Dimensiones",
    "Disc": "Disco",
    "Div": "Div",
    "Document": "Documento",
    "Dotted": "Punteado",
    "Double": "Doble",
    "Drop an image here": "Soltar una imagen aqu\xed",
    "Dropped file type is not supported": "Tipo de archivo arrastrado no soportado",
    "Edit": "Editar",
    "Embed": "Insertar",
    "Emojis": "Emojis",
    "Emojis...": "Emojis...",
    "Error": "Error",
    "Error: Form submit field collision.": "Error: colisi\xf3n del campo para el env\xedo de formulario",
    "Error: No form element found.": "Error: no se encontr\xf3 ning\xfan elemento de formulario.",
    "Extended Latin": "Lat\xedn extendido",
    "Failed to initialize plugin: {0}": "Error al inicializar el complemento: {0}",
    "Failed to load plugin url: {0}": "Error al cargar la url del complemento: {0}",
    "Failed to load plugin: {0} from url {1}": "Error al cargar el complemento: {0} desde la url {1}",
    "Failed to upload image: {0}": "Error al cargar la imagen: {0}",
    "File": "Archivo",
    "Find": "Buscar",
    "Find (if searchreplace plugin activated)": "Buscar (si el complemento de buscar y reemplazar est\xe1 activado)",
    "Find and Replace": "Buscar y reemplazar",
    "Find and replace...": "Buscar y reemplazar...",
    "Find in selection": "Buscar en la selecci\xf3n",
    "Find whole words only": "Buscar solo palabras completas",
    "Flags": "Banderas",
    "Focus to contextual toolbar": "Llevar el foco a la barra de herramientas contextual",
    "Focus to element path": "Llevar el foco a la ruta de acceso del elemento",
    "Focus to menubar": "Llevar el foco a la barra de men\xfas",
    "Focus to toolbar": "Llevar el foco a la barra de herramientas",
    "Font": "Fuente",
    "Font size {0}": "Tama\xf1o de fuente {0}",
    "Font sizes": "Tama\xf1os de fuente",
    "Font {0}": "Fuente {0}",
    "Fonts": "Fuentes",
    "Food and Drink": "Comida y bebida",
    "Footer": "Pie de p\xe1gina",
    "Format": "Formato",
    "Format {0}": "Formato {0}",
    "Formats": "Formatos",
    "Fullscreen": "Pantalla completa",
    "G": "V",
    "General": "General",
    "Gray": "Gris",
    "Green": "Verde",
    "Green component": "Componente verde",
    "Groove": "Ranura",
    "Handy Shortcuts": "Atajos \xfatiles",
    "Header": "Encabezado",
    "Header cell": "Celda de encabezado",
    "Heading 1": "Encabezado 1",
    "Heading 2": "Encabezado 2",
    "Heading 3": "Encabezado 3",
    "Heading 4": "Encabezado 4",
    "Heading 5": "Encabezado 5",
    "Heading 6": "Encabezado 6",
    "Headings": "Encabezados",
    "Height": "Alto",
    "Help": "Ayuda",
    "Hex color code": "C\xf3digo de color hexadecimal",
    "Hidden": "Oculto",
    "Horizontal align": "Alineaci\xf3n horizontal",
    "Horizontal line": "L\xednea horizontal",
    "Horizontal space": "Espacio horizontal",
    "ID": "ID",
    "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "El ID debe comenzar con una letra, seguido solo de letras, n\xfameros, guiones, puntos, dos puntos o guiones bajos",
    "Image is decorative": "La imagen es decorativa",
    "Image list": "Lista de im\xe1genes",
    "Image title": "T\xedtulo de la imagen",
    "Image...": "Imagen...",
    "ImageProxy HTTP error: Could not find Image Proxy": "Error HTTP de ImageProxy. No se pudo encontrar el proxy de imagen",
    "ImageProxy HTTP error: Incorrect Image Proxy URL": "Error HTTP de ImageProxy. La URL de proxy de imagen es incorrecta",
    "ImageProxy HTTP error: Rejected request": "Error HTTP de ImageProxy, solicitud rechazada",
    "ImageProxy HTTP error: Unknown ImageProxy error": "Error de ImageProxy HTTP. Error de ImageProxy desconocido",
    "Increase indent": "Aumentar sangr\xeda",
    "Inline": "En l\xednea",
    "Insert": "Insertar",
    "Insert Template": "Insertar plantilla",
    "Insert accordion": "Insertar acorde\xf3n",
    "Insert column after": "Insertar columna despu\xe9s",
    "Insert column before": "Insertar columna antes",
    "Insert date/time": "Insertar fecha/hora",
    "Insert image": "Insertar imagen",
    "Insert link (if link plugin activated)": "Insertar v\xednculo (si el complemento de v\xednculos est\xe1 activado)",
    "Insert row after": "Insertar fila despu\xe9s",
    "Insert row before": "Insertar fila antes",
    "Insert table": "Insertar tabla",
    "Insert template...": "Insertar plantilla...",
    "Insert video": "Insertar video",
    "Insert/Edit code sample": "Insertar/editar ejemplo de c\xf3digo",
    "Insert/edit image": "Insertar/editar imagen",
    "Insert/edit link": "Insertar/editar v\xednculo",
    "Insert/edit media": "Insertar/editar elemento multimedia",
    "Insert/edit video": "Insertar/editar video",
    "Inset": "Recuadro",
    "Invalid hex color code: {0}": "El c\xf3digo de color hexadecimal {0} no es v\xe1lido",
    "Invalid input": "Entrada no v\xe1lida",
    "Italic": "Cursiva",
    "Justify": "Justificar",
    "Keyboard Navigation": "Navegaci\xf3n con el teclado",
    "Language": "Idioma",
    "Learn more...": "M\xe1s informaci\xf3n...",
    "Left": "Izquierda",
    "Left to right": "De izquierda a derecha",
    "Light Blue": "Azul claro",
    "Light Gray": "Gris claro",
    "Light Green": "Verde claro",
    "Light Purple": "Morado claro",
    "Light Red": "Rojo claro",
    "Light Yellow": "Amarillo claro",
    "Line height": "Altura de la l\xednea",
    "Link list": "Lista de enlaces",
    "Link...": "Enlace...",
    "List Properties": "Propiedades de lista",
    "List properties...": "Propiedades de lista...",
    "Loading emojis...": "Cargando emojis...",
    "Loading...": "Cargando...",
    "Lower Alpha": "Alfab\xe9tico en min\xfasculas",
    "Lower Greek": "Griego en min\xfasculas",
    "Lower Roman": "Romano en min\xfasculas",
    "Match case": "Coincidir may\xfasculas y min\xfasculas",
    "Mathematical": "Matem\xe1ticos",
    "Media poster (Image URL)": "P\xf3ster multimedia (URL de la imagen)",
    "Media...": "Elemento multimedia...",
    "Medium Blue": "Azul medio",
    "Medium Gray": "Gris medio",
    "Medium Purple": "Morado medio",
    "Merge cells": "Combinar celdas",
    "Middle": "Centro",
    "Midnight Blue": "Azul medianoche",
    "More...": "M\xe1s...",
    "Name": "Nombre",
    "Navy Blue": "Azul marino",
    "New document": "Nuevo documento",
    "New window": "Nueva ventana",
    "Next": "Siguiente",
    "No": "No",
    "No alignment": "Sin alineaci\xf3n",
    "No color": "Sin color",
    "Nonbreaking space": "Espacio de no separaci\xf3n",
    "None": "Ninguno",
    "Numbered list": "Lista numerada",
    "OR": "O",
    "Objects": "Objetos",
    "Ok": "Aceptar",
    "Open help dialog": "Abrir di\xe1logo de ayuda",
    "Open link": "Abrir enlace",
    "Open link in...": "Abrir enlace en...",
    "Open popup menu for split buttons": "Abrir men\xfa emergente para botones divididos",
    "Orange": "Anaranjado",
    "Outset": "Inicial",
    "Page break": "Salto de p\xe1gina",
    "Paragraph": "P\xe1rrafo",
    "Paste": "Pegar",
    "Paste as text": "Pegar como texto",
    "Paste column after": "Pegar columna despu\xe9s",
    "Paste column before": "Pegar columna antes",
    "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "Pegar ahora est\xe1 en modo de texto sin formato. El contenido ahora se pegar\xe1 como texto sin formato hasta que desactive esta opci\xf3n",
    "Paste or type a link": "Pegar o escribir un enlace",
    "Paste row after": "Pegar fila despu\xe9s",
    "Paste row before": "Pegar fila antes",
    "Paste your embed code below:": "Pegue el c\xf3digo para insertar debajo:",
    "People": "Personas",
    "Plugins": "Complementos",
    "Plugins installed ({0}):": "Complementos instalados ({0}):",
    "Powered by {0}": "Con tecnolog\xeda de {0}",
    "Pre": "Pre",
    "Preferences": "Preferencias",
    "Preformatted": "Con formato previo",
    "Premium plugins:": "Complementos premium:",
    "Press the Up and Down arrow keys to resize the editor.": "Presiona las flechas Arriba y Abajo de tu teclado para cambiar el tama\xf1o del editor.",
    "Press the arrow keys to resize the editor.": "Presiona las flechas de tu teclado para cambiar el tama\xf1o del editor.",
    "Press {0} for help": "Presiona {0} para la ayuda",
    "Preview": "Vista previa",
    "Previous": "Anterior",
    "Print": "Imprimir",
    "Print...": "Imprimir...",
    "Purple": "Morado",
    "Quotations": "Comillas",
    "R": "R",
    "Range 0 to 255": "Range 0 al 255",
    "Red": "Rojo",
    "Red component": "Componente rojo",
    "Redo": "Rehacer",
    "Remove": "Quitar",
    "Remove color": "Remover color",
    "Remove link": "Eliminar v\xednculo",
    "Replace": "Remplazar",
    "Replace all": "Remplazar todo",
    "Replace with": "Remplazar con",
    "Resize": "Cambiar tama\xf1o",
    "Restore last draft": "Restaurar el \xfaltimo borrador",
    "Reveal or hide additional toolbar items": "Mostrar u ocultar elementos adicionales de la barra de herramientas",
    "Rich Text Area": "\xc1rea de texto enriquecido",
    "Rich Text Area. Press ALT-0 for help.": "\xc1rea de texto enriquecido. Pulse ALT-0 para obtener ayuda.",
    "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "\xc1rea de texto enriquecido. Pulse ALT-F9 para el men\xfa. Pulse ALT-F10 para la barra de herramientas. Pulse ALT-0 para obtener ayuda.",
    "Ridge": "Rugosidad",
    "Right": "Derecha",
    "Right to left": "De derecha a izquierda",
    "Row": "Fila",
    "Row clipboard actions": "Acciones de fila del portapapeles",
    "Row group": "Grupo de filas",
    "Row header": "Encabezado de fila",
    "Row properties": "Propiedades de fila",
    "Row type": "Tipo de fila",
    "Rows": "Filas",
    "Save": "Guardar",
    "Save (if save plugin activated)": "Guardar (si el complemento de guardar est\xe1 activado)",
    "Scope": "Alcance",
    "Search": "Buscar",
    "Select all": "Seleccionar todo",
    "Select...": "Seleccionar...",
    "Selection": "Selecci\xf3n",
    "Shortcut": "Atajo",
    "Show blocks": "Mostrar bloques",
    "Show caption": "Mostrar subt\xedtulo",
    "Show invisible characters": "Mostrar caracteres invisibles",
    "Size": "Tama\xf1o",
    "Solid": "S\xf3lido",
    "Source": "Origen",
    "Source code": "C\xf3digo fuente",
    "Special Character": "Car\xe1cter especial",
    "Special character...": "Car\xe1cter especial...",
    "Split cell": "Dividir celdas",
    "Square": "Cuadrado",
    "Start list at number": "Comenzar la lista en el n\xfamero",
    "Strikethrough": "Tachado",
    "Style": "Estilo",
    "Subscript": "Sub\xedndice",
    "Superscript": "Super\xedndice",
    "Switch to or from fullscreen mode": "Cambiar a o desde el modo de pantalla completa",
    "Symbols": "S\xedmbolos",
    "System Font": "Fuente del sistema",
    "Table": "Tabla",
    "Table caption": "Subt\xedtulo de tabla",
    "Table properties": "Propiedades de tabla",
    "Table styles": "Estilos de tabla",
    "Template": "Plantilla",
    "Templates": "Plantillas",
    "Text": "Texto",
    "Text color": "Color del texto",
    "Text color {0}": "Color de texto {0}",
    "Text to display": "Texto a mostrar",
    "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "La URL que introdujo parece ser una direcci\xf3n de correo electr\xf3nico. \xbfDesea a\xf1adir el prefijo mailto: correspondiente?",
    "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": "La URL que introdujo parece ser un v\xednculo externo. \xbfDesea a\xf1adir el prefijo http:// correspondiente?",
    "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?": "La URL que ingres\xf3 parece ser un enlace externo. Desea agregar el prefijo requerido https://?",
    "Title": "T\xedtulo",
    "To open the popup, press Shift+Enter": "Para abrir la ventana emergente, presione May\xfas+Intro",
    "Toggle accordion": "Alternar acorde\xf3n",
    "Tools": "Herramientas",
    "Top": "Arriba",
    "Travel and Places": "Viajes y lugares",
    "Turquoise": "Turquesa",
    "Underline": "Subrayado",
    "Undo": "Deshacer",
    "Upload": "Subir",
    "Uploading image": "Subiendo imagen",
    "Upper Alpha": "Alfab\xe9tico en may\xfasculas",
    "Upper Roman": "Romano en may\xfasculas",
    "Url": "Url",
    "User Defined": "Definido por el usuario",
    "Valid": "V\xe1lido",
    "Version": "Versi\xf3n",
    "Vertical align": "Alineaci\xf3n vertical",
    "Vertical space": "Espacio vertical",
    "View": "Vista",
    "Visual aids": "Ayudas visuales",
    "Warn": "Advertencia",
    "White": "Blanco",
    "Width": "Ancho",
    "Word count": "Contar palabras",
    "Words": "Palabras",
    "Words: {0}": "Palabras: {0}",
    "Yellow": "Amarillo",
    "Yes": "S\xed",
    "You are using {0}": "Est\xe1 usando {0}",
    "You have unsaved changes are you sure you want to navigate away?": "No se han guardado los cambios. \xbfSeguro que desea abandonar la p\xe1gina?",
    "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "Su navegador no admite el acceso directo al portapapeles. En su lugar, use los m\xe9todos abreviados Ctrl+X/C/V del teclado",
    "alignment": "alineaci\xf3n",
    "austral sign": "signo del austral",
    "cedi sign": "signo de cedi",
    "colon sign": "signo de dos puntos",
    "cruzeiro sign": "signo del cruzeiro",
    "currency sign": "signo de divisa",
    "dollar sign": "signo de d\xf3lar",
    "dong sign": "signo del dong",
    "drachma sign": "signo del dracma",
    "euro-currency sign": "signo de euro",
    "example": "ejemplo",
    "formatting": "formato",
    "french franc sign": "signo del franco franc\xe9s",
    "german penny symbol": "signo del penique alem\xe1n",
    "guarani sign": "signo del guaran\xed",
    "history": "historial",
    "hryvnia sign": "signo de hryvnia",
    "indentation": "sangr\xeda",
    "indian rupee sign": "signo de la rupia india",
    "kip sign": "signo del kip",
    "lira sign": "signo de la lira",
    "livre tournois sign": "signo de livre tournois",
    "manat sign": "signo de manat",
    "mill sign": "signo de mil",
    "naira sign": "signo del naira",
    "new sheqel sign": "signo de nuevo shequel",
    "nordic mark sign": "signo del marco n\xf3rdico",
    "peseta sign": "signo de la peseta",
    "peso sign": "signo del peso",
    "ruble sign": "signo de rublo",
    "rupee sign": "signo de la rupia",
    "spesmilo sign": "signo de spesmilo",
    "styles": "estilos",
    "tenge sign": "signo de tenge",
    "tugrik sign": "signo del tugrik",
    "turkish lira sign": "signo de la lira turca",
    "won sign": "signo del won",
    "yen character": "car\xe1cter del yen",
    "yen/yuan character variant one": "variante uno del car\xe1cter del yen/yuan",
    "yuan character": "car\xe1cter del yuan",
    "yuan character, in hong kong and taiwan": "car\xe1cter del yuan, en Hong Kong y Taiw\xe1n",
    "{0} characters": "{0} caracteres",
    "{0} columns, {1} rows": "{0} columnas, {1} filas",
    "{0} words": "{0} palabras"
});